<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/moje-sprawy' aria-label='E-usługi'>Moje sprawy</a>
    </li>
    @if (loading()) {
      <li>
        Ładowanie danych...
      </li>
    } @else {
      <li>
        <a routerLink="../../"
           [attr.aria-label]="'Szczegóły sprawy nr.: ' + shipment()?.caseEntity?.caseNumber">{{ shipment()?.caseEntity?.caseNumber || 'Brak numeru' }}</a>
      </li>
      <li>
        {{ shipment()?.concerns || 'Szczegóły pisma' }}
      </li>
    }
  </app-breadcrumbs>
  @if (!loading()) {
    <section>
      <h2>
        {{ shipment()?.concerns || 'Szczegóły pisma' }}
      </h2>
      @if (shipment()?.amount && confirmationDate) {
        <app-alert [closable]="false">Jeśli nie dokonałeś jeszcze płatności za ten dokument, możesz uiścić opłatę online
          w wysokości <strong>{{ (shipment()?.amount || 0) | currency }}</strong>:
          <a href="#" (click)="goToPayment($event)">
            <strong>
              Przejdź do płatności online
            </strong>
          </a>
        </app-alert>
      }
      <app-alert-container></app-alert-container>
      <div class="gov-card">
        <div class="gov-card__body">
          <div class="row">
            <div class="col-md-8">
              <app-label label="Rodzaj pisma: ">
                @if (shipment()?.incoming !== null) {
                  {{ shipment()?.incoming ? 'Przychodzące' : 'Wychodzące' }}
                } @else {
                  Brak danych
                }
              </app-label>
              <br>
              <app-label label="Nr pisma:">
                @if (shipment()?.incoming !== null) {
                  {{ shipment()?.incoming ? (shipment()?.rkwNumber || '-') : (shipment()?.rpwNumber || '-') }}
                } @else {
                  Brak danych
                }
              </app-label>
              <br>
              <app-label label="Dotyczy: ">
                {{ shipment()?.concerns || '-' }}
              </app-label>
              <br>
              <app-label [label]="shipment()?.incoming ? 'Data otrzymania:' : 'Data wysłania:'">
                {{ (shipment()?.createdAt | date) || 'Brak danych' }}
              </app-label>
              @if (shipment()?.incoming && confirmationDate) {
                <app-label class="ms-3" label="Potwierdzono odbiór:">
                  {{ confirmationDate | date }}
                </app-label>
              }
            </div>
            <div class="col-md-4 d-flex justify-content-end">
              @if (shipment()?.incoming) {
                @if (canConfirm) {
                  <div>
                    <button type="button" class="btn btn-secondary" (click)="onConfirmReceive()">
                      Potwierdź odbiór pisma
                    </button>
                  </div>
                  <br>
                }
              }
              @if (!shipment()?.incoming) {
                @if (!!shipment()?.rpwNumber) {
                  <a href='#' title='Pobierz UPP' class='btn btn-secondary' (click)='onDownloadUPP($event)'>
                    <i aria-hidden='true' class='fa fa-download'></i>
                    Pobierz UPP
                  </a>
                }
              }
            </div>
          </div>
        </div>
      </div>
      @if (shipment()?.incoming && confirmationDate) {
        <br>
        <dl class="mb-5">
          <dt class="mb-0">
            <strong>Załączniki:</strong>
          </dt>
          <dd>
            <ul class="item-list">
              @for (item of shipment()?.attachments || []; track $index) {
                <li class="mb-2">
                  <a href="#"
                     (click)="onDownloadAttachment($event, item)">{{ item.attachment?.customName || item.attachment?.originalName }}</a>
                </li>
              }
            </ul>
          </dd>
        </dl>
      } @else if (!shipment()?.incoming && (shipment()?.incoming !== null)) {
        <br>
        <dl class="mb-5">
          <dt class="mb-0">
            <strong>Załączniki:</strong>
          </dt>
          <dd>
            <ul class="item-list">
              @for (item of shipment()?.attachments || []; track $index) {
                <li class="mb-2">
                  <a href="#"
                     (click)="onDownloadAttachment($event, item)">{{ item.attachment?.customName || item.attachment?.originalName }}</a>
                </li>
              }
            </ul>
          </dd>
        </dl>
      }
    </section>
  } @else {
    <app-spinner>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  }
</app-content>
